import React from 'react';
import { UiFlex, UiGrid, UiText } from '@open-stack/ui';
import { XText, XTextType } from '../../../components/x/text/XText';
import { useCurrency } from '../../../hooks/currency';
import { XButton } from '../../../components/x/button/XButton';

interface Props {
    totalCost: number;
    onClose(): void;
}

export function SpcCheckoutHeader({ totalCost, onClose }: Props) {
    const currency = useCurrency();

    return (
        <UiFlex justifyContent="space-between">
            <UiGrid gap={0}>
                <XText type={XTextType.LABEL}>Pay for order</XText>

                <XText type={XTextType.TITLE_LARGE}>
                    Total: <UiText color="success">{currency.format(totalCost)}</UiText>
                </XText>
            </UiGrid>

            <XButton onClick={onClose} icon="close" variant="outlined" />
        </UiFlex>
    );
}
